import { useState } from "react"
import { DropdownButton } from "../atoms/buttons"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { SettingHeader } from "./SettingHeader"
import { use } from "react"

export const ThemeFontContent = ({fontData,fonts}) => {
    const [fontOptions,setFontOptions] = useState([
        {
            title: "Scherm titels",
            description: "Choose a font family for your theme",
            key:"--screen-title",
            size:26,
            active: true,
            options:[{content:22, id:1}, {content:30, id:2}, {content:40, id:3}]
        },
        {
            title: "Navigatie menu",
            key:"--nav-item-size",
            size: 18,
            description: "Choose a font size for your theme",
            active: false,
            options:[{content:10, id:1}, {content:12, id:2}, {content:14, id:3}, {content:16, id:4}, {content:18, id:5}]
        },
        {   
            title: "Instellingen titels",
            key:"--settings-header-size",
            size:14,
            description: "Choose a font weight for your theme",
            active: false,
            options:[{content:20, id:1}, {content:24, id:2}, {content:30, id:3}]
        }
        ,
        {
            title: "Sub titels",
            key:"--settings-sub-header-size",
            size: 12,
            description: "Choose a font weight for your theme",
            active: false,
            options:[{content:16, id:1}, {content:18, id:2}, {content:22, id:3}]
        }
    ])
    const handleSelect = (index,id) => {
const copyFontOptions = [...fontOptions]
copyFontOptions[index].size = copyFontOptions[index].options.filter((row) => row.id == id)[0].content
setFontOptions(copyFontOptions)

fontData({key:copyFontOptions[index].key,size:copyFontOptions[index].options.filter((row) => row.id == id)[0].content / 16})
}
    return (
        <VerticalLayout className="phone-theme-content theme-create-content" >
            <SettingHeader
                className={"phone-setting-header"}
                title="Tekstgrootte en dikte"
                description="Pas hier de tekst en lettertype aan"

            />
            {fontOptions.map((item, index) => {
                return (
                    <FontOption
                        key={index}
                        title={item.title}
                        size={item.size}
                        options={item.options}
                        weights={item.weights}
                        select={(value) => handleSelect(index,value)}
                    />
                )
            })}
        </VerticalLayout>

    )
}

const FontOption = ({ title, options,weights,size,select }) => {
    const [currentSize,setCurrentSize] = useState(0)
    return (
        <HorizontalLayout className="font-option">
            <h3 className="standard-text-color" style={{fontSize:currentSize || size + "px", fontWeight:"300", marginRight:"1rem"}} >{title}</h3>
            <HorizontalLayout style={{width:"max-content", gap:"1rem"}}>
            <DropdownButton optionSelected={(value) => select(value)} content={size} dropdown={options} />
            </HorizontalLayout>
        </HorizontalLayout>
    )
}
